export default __webpack_public_path__ + "static/media/cleanproStep3.c0602439.png";